/**溯源记录 */
export default [
    {
        name: 'instance',
        path: 'instance',
        meta: { title: '溯源记录' },
        component: () => import('@/pages/instance/index.vue')
    }
]